import {useAppSelector} from '../../../app/hooks/useAppSelector';
import {useGetTenantsQuery} from '../../../app/services/tenantApi';
import {selectTenantId} from '../../auth/authSlice';

export const useActiveTenant = () => {
  const tenantId = useAppSelector(selectTenantId);
  const {data: tenants = []} = useGetTenantsQuery(undefined, {skip: tenantId === 1});

  return tenants.find((tenant) => tenant.id === tenantId);
};
